import { Injectable } from '@angular/core';
import {
  DialogBasicComponent,
  I2gDialogService,
  IconSizesEnum,
} from 'i2g-ng-ui';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { AccountDataService } from '../account-data/account-data.service';
import { filter, map, take } from 'rxjs/operators';
import { User } from '../account-data/user.model';
import { interval, Observable } from 'rxjs';
import { IResponseInfo } from 'i2g-ng-utils';
import {
  COOKIE_INTERVAL,
  DELETE_COOKIE_DELAY,
  VERIFY_ACCOUNT_COOKIE,
} from './verify-account.constants';
import { CookieService } from '../browser-manager-data/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class VerifyAccountService {
  constructor(
    private _dialogService: I2gDialogService,
    private _accountDataService: AccountDataService,
    private _authHttpService: AuthHttpService,
    private _cookieService: CookieService,
    private _translateService: TranslateService
  ) {}

  openVerificationEmailSentDialog() {
    this._accountDataService
      .getUser()
      .pipe(
        filter((x) => !!x),
        take(1)
      )
      .subscribe((user: User) => {
        const { email } = user;
        this._dialogService
          .openDialog(DialogBasicComponent, {
            title: this._translateService.instant(
              'DIALOG.PAYMENTS.DESCRIPTION.EMAIL_VERIFICATION_SENT'
            ),
            body: this._translateService.instant(
              'VERIFY_ACCOUNT.EMAIL_VERIFICATION_INSTRUCTION',
              {
                email,
              }
            ),
            primaryButtonText: this._translateService.instant('ACTION.GOT_IT'),
            icon: {
              name: 'info-xlarge',
              size: IconSizesEnum.x_large,
            },
          })
          .subscribe();
      });
  }

  resendVerificationEmail(): Observable<IResponseInfo> {
    return this._authHttpService.post('/verification/email_verify_attempt');
  }

  didVerifyAccount(): Observable<boolean> {
    return interval(COOKIE_INTERVAL).pipe(
      map(
        (): boolean => !!this._cookieService.getCookie(VERIFY_ACCOUNT_COOKIE)
      ),
      filter((cookie) => !!cookie),
      take(1)
    );
  }

  clearVerifyAccountCookie() {
    // clear cookie with some delay to make sure all web app tabs have time refetch '/features'
    setTimeout(
      () => this._cookieService.removeCookie(VERIFY_ACCOUNT_COOKIE),
      DELETE_COOKIE_DELAY
    );
  }
}
